import { DateField, TextField } from '@servicetitan/anvil2-react-hook-form';

interface PassportFieldsProps {
    fieldPrefix?: string;
}

export const PassportFields = ({ fieldPrefix = '' }: PassportFieldsProps) => {
    return (
        <>
            <TextField
                label="ID Number"
                name={[fieldPrefix, 'applicantId.documentId'].join('.')}
                required
            />
            <DateField
                label="Issue Date"
                name={[fieldPrefix, 'applicantId.issueDate'].join('.')}
                required
            />
            <DateField
                label="Expiration Date"
                name={[fieldPrefix, 'applicantId.expirationDate'].join('.')}
                required
            />
            <TextField
                label="Country"
                name={[fieldPrefix, 'applicantId.country'].join('.')}
                required
            />
        </>
    );
};
